import React, { useState, useEffect } from 'react';
import style from './style.module.scss';
import PromptItem from '../item';
import promptStore from 'stores/prompt';
import { observer } from 'mobx-react';

const PromptContainer = observer(() => {
  const { prompts, clear, checkMaxPromptList } = promptStore;
  const [items, setItems] = useState([]);

  useEffect(() => {
    setItems(prompts);

    if (checkMaxPromptList) {
      prompts.forEach((item, idx) => {
        if (idx > 2) {
          item.remove();
        }
      });
    }
  }, [prompts, checkMaxPromptList]);

  if (items.length > 0) {
    return (
      <div className={style.toast}>
        <div className={style.header}>
          <p>득점 알림</p>
          <div className={style.close}>
            <button onClick={clear} />
          </div>
        </div>
        <ul className={style.contents}>
          {items.map((item) => {
            return <PromptItem item={item} key={item.id} />;
          })}
        </ul>
      </div>
    );
  } else {
    return null;
  }
});

export default PromptContainer;
